export const theme = {
    color: {
        teal: "#008080",
        silver: "#ccc",
        alto: "#ddd",
        green: "#008000",
        crimson: "#dc143c",
        white: "#fff",
        lightgrey: "#d3d3d3",
        black: "#000",
    },
    breakpoint: {
        mobileMax: 768,
    },
};